export default {
    init() {

        if ($(".module-img-gallery")[0]) {
            $(".module-img-gallery").each(function() {
                var imgGallery = $(this);
                var indexSlide = 0;
                var wrapperCount = imgGallery.find('.single-bloc').length;
                const circleNext = imgGallery.find('.slider-next-button .circle-countdown .circle')
                const intervalDuration = 7000;
                var myTimer = setInterval(changeSlide, intervalDuration);
                let imgGalleryScroll = 0

                circleNext.addClass('running');

                if (imgGallery.find(".gallery-container")[0].offsetWidth < imgGallery.find(".gallery-container")[0].scrollWidth) {
                    // your element have overflow
                    imgGallery.find(".control-navigation").removeClass("hide-gallery");
                } else {
                    // your element doesn't have overflow
                    imgGallery.find(".control-navigation").addClass("hide-gallery");
                }


                $(window).resize(function(){

                    if (imgGallery.find(".gallery-container")[0].offsetWidth < imgGallery.find(".gallery-container")[0].scrollWidth) {
                        // your element have overflow
                        imgGallery.find(".control-navigation").removeClass("hide-gallery");
                    } else {
                        // your element doesn't have overflow
                        imgGallery.find(".control-navigation").addClass("hide-gallery");
                    }
                })

                // Récupère les boutons suivant et précédent
                var next = imgGallery.find(".slider-next-button");
                var prev = imgGallery.find(".slider-prev-button");

                // Au clique du bouton "suivant" le scroll s'anime vers le prochain wrapper
                next.on('click', function() {
                    const easchItemtoMove = imgGallery.find('.single-bloc')
                    const wrapperWidth = easchItemtoMove.outerWidth()
                    const portfolioScrollLive = imgGallery.find(".gallery-container").scrollLeft()
                    const prevIndexSlide = indexSlide

                    indexSlide = Math.floor(portfolioScrollLive / wrapperWidth)

                    if (prevIndexSlide === indexSlide + 1) {
                        indexSlide = -1
                    }

                    disableAutoSlider()
                    changeSlide()
                });

                // Au clique du bouton "précédent" le scroll s'anime vers le précédent wrapper
                prev.on('click', function() {
                    const easchItemtoMove = imgGallery.find('.single-bloc')
                    const wrapperWidth = easchItemtoMove.outerWidth()
                    const portfolioScrollLive = imgGallery.find(".gallery-container").scrollLeft()

                    indexSlide = Math.round(portfolioScrollLive / wrapperWidth)

                    disableAutoSlider()
                    changeSlide(true)
                });

                if (myTimer) {
                    $('.gallery-container').on('touchmove', function() {
                        if (myTimer) {
                            disableAutoSlider()
                        }
                    })
                }

                function disableAutoSlider() {
                    clearInterval(myTimer);
                    myTimer = null;
                    circleNext.removeClass('running');
                }

                function changeSlide(previous) {

                    const isMobile = $(window).width() < 768
                    const portfolioScrollLive = imgGallery.find(".gallery-container").scrollLeft()

                    if (portfolioScrollLive !== imgGalleryScroll && myTimer && !isMobile) {
                        disableAutoSlider()
                        return
                    }

                    const easchItemtoMove = imgGallery.find('.single-bloc')
                    const wrapperWidth = easchItemtoMove.outerWidth() + 15

                    if (!previous) {
                        if (indexSlide === easchItemtoMove.length - 1) {
                            indexSlide = 0;
                        } else {
                            indexSlide++;
                        }
                    } else {
                        indexSlide =  indexSlide === 0 ? easchItemtoMove.length - 1 : indexSlide - 1
                    }

                    circleNext.removeClass('running');
                    circleNext[0].offsetHeight; //forces reflow
                    if (myTimer) {
                        circleNext.addClass('running');
                    }

                    imgGallery.find(".gallery-container").animate({ scrollLeft: wrapperWidth * indexSlide }, 1000, 'swing', function () {
                        imgGalleryScroll = $(this).scrollLeft()
                    });
                }

                $(".img-gallery").addClass("hide-gallery");
                $(".img-gallery").eq(0).removeClass("hide-gallery");
                $(".gallery-selection").eq(0).addClass("gallery-selection-active");

                $(".gallery-selection").on("click", function () {
                    var gallery_index = $(this).index();

                    $(".gallery-selection").removeClass("gallery-selection-active");
                    $(this).addClass("gallery-selection-active");

                    $(".img-gallery").addClass("hide-gallery");
                    $(".img-gallery").eq(gallery_index).removeClass("hide-gallery");
                });

                const ele = imgGallery.find(".gallery-container")[0];
                ele.style.cursor = 'grab';

                let pos = { top: 0, left: 0, x: 0, y: 0 };

                const mouseDownHandler = function(e) {
                    ele.style.cursor = 'grabbing';
                    ele.style.userSelect = 'none';

                    pos = {
                        left: ele.scrollLeft,
                        top: ele.scrollTop,
                        // Get the current mouse position
                        x: e.clientX,
                        y: e.clientY,
                    };

                    document.addEventListener('mousemove', mouseMoveHandler);
                    document.addEventListener('mouseup', mouseUpHandler);
                };

                const mouseMoveHandler = function(e) {

                    // How far the mouse has been moved
                    const dx = e.clientX - pos.x;
                    const dy = e.clientY - pos.y;

                    // Scroll the element
                    ele.scrollTop = pos.top - dy;
                    ele.scrollLeft = pos.left - dx;
                };

                const mouseUpHandler = function() {

                    ele.style.cursor = 'grab';
                    ele.style.removeProperty('user-select');

                    document.removeEventListener('mousemove', mouseMoveHandler);
                    document.removeEventListener('mouseup', mouseUpHandler);
                };

                // Attach the handler
                ele.addEventListener('mousedown', mouseDownHandler);
            });
        }

    }
}